import type { ISeoConfig } from './seo.service';

export const DEFAULT_SEO: ISeoConfig = {
  titleKey: 'SEO.HOME_TITLE',
  descriptionKey: 'SEO.HOME_DESCRIPTION',
};
